export default {
    root: function (_a) {
        var props = _a.props;
        return ({
            class: [
                'tw-rounded-md tw-border-solid tw-border-0 tw-border-l-4 dark:tw-text-white',
                {
                    'tw-bg-sky-100 tw-border-sky-500 tw-text-sky-700 dark:tw-bg-sky-700 dark:tw-border-sky-700 dark:tw-bg-sky-900': props.severity == 'info',
                    'tw-bg-green-100 tw-border-green-500 tw-text-green-700 dark:tw-border-green-600 dark:tw-bg-green-800': props.severity == 'success',
                    'tw-bg-orange-100 tw-border-orange-500 tw-text-orange-700 dark:tw-border-orange-600 dark:tw-bg-orange-800': props.severity == 'warn',
                    'tw-bg-red-100 tw-border-red-500 tw-text-red-700 dark:tw-border-red-700 dark:tw-bg-red-900': props.severity == 'error',
                    'tw-bg-gray-100 tw-border-gray-500 tw-text-gray-700 dark:tw-border-gray-600 dark:tw-bg-gray-800': props.severity == 'secondary',
                },
            ],
        });
    },
    content: function (_a) {
        var props = _a.props;
        return ({
            class: [
                'tw-flex md:tw-items-center tw-gap-x-2',
                {
                    'tw-py-3 tw-px-6': !props.size,
                    'tw-py-2 tw-px-4': props.size === 'small',
                    'tw-py-4 tw-px-6': props.size === 'large',
                },
            ],
        });
    },
    icon: {
        class: ['tw-size-5 tw-min-w-5 tw-min-h-5', 'tw-text-lg tw-mr-3', 'tw-mt-0.5 md:tw-mt-0'],
    },
    text: function (_a) {
        var props = _a.props;
        return ({
            class: {
                'tw-text-base tw-font-light': !props.size,
                'tw-text-sm tw-font-light': props.size === 'small',
                'tw-text-lg tw-font-light': props.size === 'large',
            },
        });
    },
    closebutton: {
        class: [
            'tw-size-8 tw-min-w-8 tw-min-h-8 tw-rounded-full tw-bg-transparent tw-transition tw-duration-200 tw-ease-in-out',
            'tw--mt-0.5 md:tw-mt-0',
            'tw-ml-auto tw-overflow-hidden tw-relative',
            'tw-flex tw-items-center tw-justify-center',
            'tw-self-start',
            'hover:tw-bg-white/30 dark:hover:tw-bg-white/10',
        ],
    },
    transition: {
        enterFromClass: 'tw-opacity-0 tw-translate-x-0 tw--translate-y-2/4 tw-translate-z-0',
        enterActiveClass: 'tw-transition-all tw-duration-300 tw-ease-out',
        leaveFromClass: 'tw-max-h-40',
        leaveActiveClass: 'tw-overflow-hidden tw-transition-all tw-duration-300 tw-ease-in',
        leaveToClass: 'tw-max-h-0 tw-opacity-0 !tw-m-0',
    },
};
